import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { AccessService } from 'src/app/core/services/auth/access/access.service';
import { AuthService } from '../../services/auth/auth.service';
import { AccessActions } from './access.actions';

@Injectable()
export class AccessEffects {
  private actions$ = inject(Actions);
  private accessService = inject(AccessService);
  private authService = inject(AuthService);

  // Load user access data
  loadUserAccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AccessActions.loadUserAccess),
      mergeMap(() => {
        return this.authService.getCurrentUser().pipe(
          switchMap((userData) => {
            if (!userData) {
              return of(
                AccessActions.loadUserAccessFailure({
                  error: 'User data not found',
                })
              );
            }
            return this.accessService.getUserAccess(userData.idnumber).pipe(
              map((accessData) => {
                if (accessData) {
                  return AccessActions.loadUserAccessSuccess({ accessData });
                } else {
                  return AccessActions.loadUserAccessFailure({
                    error: 'Access data not found',
                  });
                }
              }),
              catchError((error) =>
                of(AccessActions.loadUserAccessFailure({ error }))
              )
            );
          }),
          catchError((error) =>
            of(AccessActions.loadUserAccessFailure({ error }))
          )
        );
      })
    )
  );
}
